import { useQuery, useQueryClient } from 'react-query'

import { user_role } from '@/services/backend/config/entities'

import { UsuarioService } from '../services/usuario.service'

export const useUsuarios = (search?: string, role?: user_role) => {
  const queryClient = useQueryClient()
  const queryKey = ['usuarios', { search, role }]

  const query = useQuery(queryKey, async () => {
    return await UsuarioService.search({ search, role })
  })

  const invalidate = () => queryClient.invalidateQueries(queryKey)

  return { query, invalidate }
}
